import slider from '@/components/views/Home/slider';
export default {
  name: 'my-space',
  components: {
    'slider': slider
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/views/MySpace/MySpace.js